import autoBind from 'react-autobind'
import React from 'react';
import axios from 'axios';

import '../views/Contact.css'


class ContactForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      name:"",
      email:"",
      tel:"",
      message:"",
      nacin:"",
      location:"contact",
      startTransition: false,
      nextScreen: false,
      inputOk1: true,
      inputOk2: true,
      inputOk3: true,
    };
    autoBind(this);
  }

  handleClick2(){
    this.setState({startTransition: !this.state.startTransition});
    if(this.props.onClick()){
      this.props.onClick();
    }
  }
  handleRegister1(){
      if(this.state.name === ""){
        this.setState({inputOk1:false});
      } else {
        this.setState({inputOk1:true});
      }
      this.setState({inputOk3:true});
      if(this.state.tel === ""){
        this.setState({inputOk2:false});
      } else {
        this.setState({inputOk2:true});
      }
      if(this.state.name !== "" && this.state.tel !== ""){

        this.props.onClick();
        this.setState({nacin: "Poklicali vas bomo v najkrajšem možnem času. V kolikor našega odgovora ne prejmete v roku treh delovnih dni nam to prosim sporočite na elektronski naslov", startTransition: true});
        setTimeout(() => {
          axios.post('https://email.mtoffice.net/mail1', this.state).then(response => {
              console.log(response);
            })
            .catch(error => {
              console.log(error);
            });
          setTimeout(() => this.setState({ nextScreen: true}), 400);
        }, 200);
        setTimeout(() => this.setState({ nextScreen: true}), 400);
      }
  }
  handleRegister2(){
      if(this.state.name === ""){
        this.setState({inputOk1:false});
      } else {
        this.setState({inputOk1:true});
      }

      this.setState({inputOk2:true});

      if(this.state.email === ""){
        this.setState({inputOk3:false});
      } else {
        this.setState({inputOk3:true});
      }
      if(this.state.name !== "" && this.state.email !== ""){
        this.props.onClick();
        this.setState({nacin: "Odpisali vam bomo v najkrajšem možnem času. V kolikor našega odgovora ne prejmete v roku treh delovnih dni nam to prosim sporočite na elektronski naslov", startTransition: true});
        setTimeout(() => {
          axios.post('https://email.mtoffice.net/mail1', this.state).then(response => {
              console.log(response);
            })
            .catch(error => {
              console.log(error);
            });
          setTimeout(() => this.setState({ nextScreen: true}), 400);
        }, 200);
        setTimeout(() => this.setState({ nextScreen: true}), 400);
      }
  }

  handleClose(){
    this.props.onClick();
    this.setState({ startTransition: false});
    this.setState({ nextScreen: false});
  }

  render() {
    const inputOkState1 = this.state.inputOk1 ? "contactFormBoxInputOk" : "contactFormBoxInputError";
    const inputOkState2 = this.state.inputOk2 ? "contactFormBoxInputOk" : "contactFormBoxInputError";
    const inputOkState3 = this.state.inputOk3 ? "contactFormBoxInputOk" : "contactFormBoxInputError";
    const firstScreenState = this.state.startTransition ? "contactFormWrapperOut" : "contactFormWrapperIn";

    
    return (
    <div>
      {!this.state.nextScreen ? 
        <div className={firstScreenState}>
          <div className="contactFormFlex">
            <input
              type="name"
              className={inputOkState1+" contactFormBoxInput contactFormBoxInput1"}
              placeholder="FULL NAME"
              onChange={e => this.setState({ name: e.nativeEvent.target.value })}
            />
            <input
              type="tel"
              className={inputOkState2+" contactFormBoxInput"}
              placeholder="PHONE"
              onChange={e => this.setState({ tel: e.nativeEvent.target.value })}
            />
            <input
              type="email"
              className={inputOkState3+" contactFormBoxInput"}
              placeholder="EMAIL"
              onChange={e => this.setState({ email: e.nativeEvent.target.value })}
            />
            <textarea
              rows="3"
              type="text"
              className="contactFormBoxInput"
              placeholder="MESSAGE"
              onChange={e => this.setState({ message: e.nativeEvent.target.value })}
            />
            <div className="contactFormText">HOW CAN WE CONTACT YOU?</div>
            <div className="contactFormButtonWrapper">
              <div onClick={this.handleRegister1} className="contactFormButton">PHONE</div>
              <div onClick={this.handleRegister2} className="contactFormButton">EMAIL</div>
            </div>
            {!this.state.inputOk1 || !this.state.inputOk2 || !this.state.inputOk3 ?
              <div className="contactFormRedText">Please fill-in the red inputs</div>
            :
              null
            }
          </div>
        </div>
        :
        <div className="contactFormNextScreenSecond">
            <div className="contactFormTextCenter">{this.state.name}, THANK YOU FOR CONTACTING US.</div>
            <div className="contactFormTextCenterSmall">
              WE WILL TRY OUR BEST, SO THAT OUR RESPONSE IS AS FAST AS APEX.
            </div>
            <svg className="checkmark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52">
            <circle className="checkmark__circle" cx="26" cy="26" r="25" fill="none"/>
            <path className="checkmark__check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8"/>
          </svg>

          <div onClick={this.handleClose} className="contactFormButton1" to="/contact">BACK ON CONTACT
          </div>

        </div>
        }
      </div>
    );
  }
}


export default ContactForm;



// WEBPACK FOOTER //
// ./src/components/ContactForm.js